import { takeLatest, call, put } from 'redux-saga/effects';
import { authApi, dataApi } from '../../apis';
import * as constants from './constants';
import * as actions from './actions';
import {
  setMarket,
  setUserIsGlobal,
  setUserIsServiceOffice
} from '../app/actions';
import { APP_START } from '../app/constants';
import {
  persistStringToLocalStorage,
  persistObjectToLocalStorage,
  removeLocalStorageItem,
  getLocalStorageItem,
  getLocalStorageObject
} from '../utils/localStorage';

function* setInitialMarketAndLanguage(markets) {
  const persistedMarket = yield call(getLocalStorageObject, 'market');
  const marketNames = markets.map(marketObj => marketObj.market);
  if (persistedMarket && marketNames.indexOf(persistedMarket.market) > -1) {
    // The persisted market name exists in the authenticated users
    // list of markets
    // persistedMarket.ifoodPPSILanguageCodes = markets.filter(
    //   marketObj => marketObj.market === persistedMarket.market
    // )[0].ifoodPPSILanguageCodes;
    yield put(setMarket({ market: persistedMarket }));
  } else {
    // The persisted market name did not exist in the authenticated users market
    // list, instead use one of the markets in the signed in user's market list
    yield put(setMarket({ market: markets[0], refetch: false }));
  }
}

function* setUserType(user) {
  const isGlobal = user.ifsUser;
  if (isGlobal) {
    yield put(setUserIsGlobal());
  } else {
    yield put(setUserIsServiceOffice());
  }
}

function* deleteUserData() {
  yield call(removeLocalStorageItem, 'token');
  yield call(removeLocalStorageItem, 'user');
}

function* saveUserData(token, user) {
  yield call(persistStringToLocalStorage, 'token', token);
  yield call(persistObjectToLocalStorage, 'user', user);
}

function* getPersistedUserData() {
  const token = yield call(getLocalStorageItem, 'token');
  const user = yield call(getLocalStorageObject, 'user');
  return { user, token };
}

function* logout(action) {
  if (!action.payload) {
    yield call(deleteUserData);
    yield call(authApi.removeAuthToken);
  }
}

function* loadUser(token, user) {
  yield call(authApi.setAuthToken, token);
  yield call(setInitialMarketAndLanguage, user.ppsiMarkets);
  yield call(setUserType, user);
  yield put(actions.userLoaded(user));
}

function* authenticate(action) {
  try {
    const response = yield call(authApi.authenticate, action.payload);
    const {
      data: { token, user, ppsiAdmin }
    } = response;

    yield call(saveUserData, token, user);
    yield call(loadUser, token, user);
    if (ppsiAdmin !== undefined) {
      yield localStorage.setItem('ppsiAdmin', JSON.stringify(ppsiAdmin));
    }
    yield put(actions.authenticateDone());
    yield call(dataApi.saveIffLogin);
  } catch (err) {
    yield put(actions.authenticateFail('Could not validate login token'));
  }
}

function* loadCachedUser() {
  const { user, token } = yield call(getPersistedUserData);
  if (user && token) {
    yield call(loadUser, token, user);
  }
  yield put(actions.loadCachedUserAttempted());
}

export default [
  takeLatest(constants.LOGOUT, logout),
  takeLatest(constants.AUTHENTICATE, authenticate),
  takeLatest(APP_START, loadCachedUser)
];
